import React, {useContext, useEffect, useState} from 'react';
import {Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import Button from "@mui/material/Button";
import clsx from "clsx";
import {AnagraficaContext} from "../../../../App";
import {useParams} from "react-router-dom";
import {getAnagraficaById} from "../../../../services/AnagraficaServices";
import {useFormContext} from "react-hook-form";

const AnagraficaCard = ({
	                        onSearch,
	                        aggiungiPaziente,
	                        subHeader,
	                        moreInfo = true,
	                        showButton = true,
	                        title = "Anagrafica paziente",
                        }) => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const {reset} = useFormContext();
	const [isGet, setIsGet] = useState(false);
	let {idSoggetto} = useParams();
	
	useEffect(() => {
		if (idSoggetto) {
			setIsGet(true);
			getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
		}
	}, [idSoggetto, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (isGet && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			setIsGet(false);
			reset({...anagraficaContext.state.anagrafica});
		}
	}, [isGet, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica, reset, anagraficaContext.state.anagrafica]);
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>{title}</b></Typography>}
					subheader={subHeader ? subHeader : "Inserisci almeno un telefono o una email (o entrambi) per poter registrare la chiamata. In caso il paziente sia" +
						" sprovvisto di entrambi è necessario chiedere un contatto di una persona a lui vicina per poter essere ricontattato / avere un suo riferimento"}
				/>
				<CardContent style={{flexGrow: 1}}>
					<Grid container spacing={3}>
						<AnagraficaCompleta classes={classes} intro={"false"} moreInfo={moreInfo} anonimo={true}
						                    anagrafica={anagraficaContext.state.anagrafica}/>
					</Grid>
				</CardContent>
				{showButton && <CardActions className={classes.flexRight}>
					<Tooltip
						title={"Cerca tra le pratiche con gli stessi campi da te compilati (nome, cognome, codice fiscale, ...)"}>
						<Button variant={"text"} disableElevation size="small" color="inherit"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={onSearch}>
							<b>Cerca</b>
						</Button>
					</Tooltip>
					<Tooltip title={"Associa più pazienti al ticket indicando la relazione tra di essi"}>
						<Button variant={"contained"} disableElevation size="small" color="primary"
						        style={{borderRadius: 24}}
						        className={clsx(classes.roundButton)} onClick={aggiungiPaziente}>
							<b>Aggiungi paziente</b>
						</Button>
					</Tooltip>
				</CardActions>}
			</Card>
		</React.Fragment>
	);
};

export default React.memo(AnagraficaCard)
